// calculatorLinks.ts — F15b: cross-link data for the SEO interlinking between calculators.
// Paths are ROOT-RELATIVE with trailing slash (F15a canonical convention); the sitemap and
// the catalog test derive the same URLs from these paths + CALC_HOST.

export interface CalculatorLink {
    /** Root-relative path with trailing slash — also the canonical path of the page. */
    path: string;
    label: string;
}

export const CALCULATOR_CROSS_LINKS: CalculatorLink[] = [
    { path: '/calculadoras/irpf-2025/', label: 'Calculadora IRPF 2025 (todas las CCAA)' },
    { path: '/calculadoras/modelo-130/', label: 'Calculadora Modelo 130 (pago fraccionado IRPF)' },
    { path: '/calculadoras/modelo-303/', label: 'Calculadora Modelo 303 (IVA trimestral)' },
    { path: '/calculadoras/plan-pensiones/', label: '¿Cuánto desgrava un plan de pensiones?' },
];
